// Import the authentication hook to manage users' authentication state.
import { useAuth } from "react-oidc-context";

import AuthErrorHandler from "./components/auth/AuthErrorHandler";
import LoadingSpinner from "./components/layout/LoadingSpinner";
import { useDisableNumberInputScroll } from "./hooks/useDisableInputScroll";
import { AppRoutes } from "./routes/AppRoutes";
import { AuthState } from "./types/auth.types";

const App: React.FC = () => {
  // Disable scroll on number inputs globally
  useDisableNumberInputScroll();
  // Retrieve the authentication state (loading/authenticated/error) using the useAuth hook to manage app flow based on user status.
  const auth = useAuth() as AuthState;
  // Display a loading spinner when the authentication is in progress for better UI experience.
  if (auth.isLoading) return <LoadingSpinner />;

  if (auth.error)
    // Return both the auth error handler and the error message
    return (
      <>
        {/* Include the AuthErrorHandler component to handle the back button navigation issue. */}
        {/* Without importing the component below, if a user hits the browser's back button after they are logged in, they are prompted to log in again. */}
        {/* If they do, AWS Cognito uses the same code it used the first time to retrieve user's access token. However, that code is a one use only. Therefore, the user is hit with a 'no matching state' error coming from AWS Cognito. */}
        <AuthErrorHandler />
        {/* Return an error message if the authentication fails for any other reason. */}
        {/* TODO: improve the UI of the error message.  */}
        <div>Encountered an error: {auth.error.message}</div>
      </>
    );
  // Render the app routes if the authentication is successful.
  return <AppRoutes />;
};

export default App;
